import { useCallback, useState, useEffect } from 'react';
import Raven from 'raven-js';
import { getOnboardingBeaconDismissStatus, setOnboardingBeaconDismissStatus } from '../api/onboardingBeaconStatus';
export const OnboardingBeaconStatus = {
  PENDING: 'PENDING',
  DISMISSED: 'DISMISSED',
  NOT_DISMISSED: 'NOT_DISMISSED'
};
export const useOnboardingBeaconsStatus = onboardingBeaconId => {
  const [onboardingBeaconStatus, setOnboardingBeaconStatus] = useState(OnboardingBeaconStatus.PENDING);
  useEffect(() => {
    getOnboardingBeaconDismissStatus(onboardingBeaconId).then(dismissedFromApi => {
      setOnboardingBeaconStatus(dismissedFromApi ? OnboardingBeaconStatus.DISMISSED : OnboardingBeaconStatus.NOT_DISMISSED);
    }).catch(err => {
      setOnboardingBeaconStatus(OnboardingBeaconStatus.DISMISSED);
      Raven.captureException(err, {
        extra: {
          onboardingBeaconId
        },
        tags: {
          'onboarding-beacons': 'true'
        }
      });
    });
  }, [onboardingBeaconId]);
  const turnOffOnboardingBeacon = useCallback(async () => {
    // optimistic update
    setOnboardingBeaconStatus(OnboardingBeaconStatus.DISMISSED);
    try {
      await setOnboardingBeaconDismissStatus(onboardingBeaconId);
    } catch (err) {
      Raven.captureException(err, {
        extra: {
          onboardingBeaconId
        },
        tags: {
          'onboarding-beacons': 'true'
        }
      });
    }
  }, [onboardingBeaconId]);
  return {
    onboardingBeaconStatus,
    turnOffOnboardingBeacon
  };
};